var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 52,
    viewBox: "0 0 181 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    d: "M173.833 52H7.16667C3.50167 52 0.5 49.0734 0.5 45.5V6.5C0.5 2.92663 3.50167 2.74817e-06 7.16667 2.74817e-06H173.833C177.498 2.74817e-06 180.5 2.92663 180.5 6.5V45.5C180.5 49.0734 177.498 52 173.833 52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Border",
    d: "M173.833 1.04162C176.92 1.04162 179.432 3.4905 179.432 6.5V45.5C179.432 48.5095 176.92 50.9584 173.833 50.9584H7.16667C4.08 50.9584 1.56833 48.5095 1.56833 45.5V6.5C1.56833 3.4905 4.08 1.04162 7.16667 1.04162H173.833ZM173.833 2.74817e-06H7.16667C3.50167 2.74817e-06 0.5 2.92663 0.5 6.5V45.5C0.5 49.0734 3.50167 52 7.16667 52H173.833C177.498 52 180.5 49.0734 180.5 45.5V6.5C180.5 2.92663 177.498 2.74817e-06 173.833 2.74817e-06Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4152 9.79556C14.0235 10.1953 13.7969 10.8177 13.7969 11.6237V40.3732C13.7969 41.1792 14.0235 41.8016 14.4152 42.2013L14.5119 42.2891L31.0352 26.1853V25.8051L14.5119 9.70131L14.4152 9.79556Z",
    fill: "url(#paint0_linear_8315_15206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.5329 31.5547L31.0312 26.1841V25.8038L36.5396 20.4332L36.6629 20.5031L43.1862 24.1219C45.0479 25.1489 45.0479 26.8389 43.1862 27.8724L36.6629 31.4848L36.5329 31.5547Z",
    fill: "url(#paint1_linear_8315_15206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.6657 31.4883L31.0341 25.9974L14.4141 42.2035C15.0324 42.8373 16.0407 42.9137 17.1874 42.2799L36.6657 31.4883Z",
    fill: "url(#paint2_linear_8315_15206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.6657 20.5091L17.1874 9.71751C16.0407 9.09025 15.0324 9.16663 14.4141 9.80038L31.0341 26L36.6657 20.5091Z",
    fill: "url(#paint3_linear_8315_15206)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GET IT ON"
  }, /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M63.7195 13.3221C63.7195 14.4076 63.3861 15.2769 62.7295 15.9253C61.9745 16.6939 60.9911 17.0807 59.7861 17.0807C58.6345 17.0807 57.6511 16.6874 56.8445 15.9123C56.0361 15.1258 55.6328 14.1606 55.6328 13.0052C55.6328 11.8498 56.0361 10.8846 56.8445 10.1046C57.6511 9.32294 58.6345 8.92969 59.7861 8.92969C60.3595 8.92969 60.9061 9.04506 61.4278 9.25956C61.9478 9.47569 62.3711 9.76819 62.6778 10.1289L61.9811 10.8147C61.4461 10.1988 60.7178 9.89494 59.7861 9.89494C58.9461 9.89494 58.2178 10.1809 57.5995 10.7578C56.9878 11.3363 56.6811 12.0854 56.6811 13.0052C56.6811 13.9249 56.9878 14.6806 57.5995 15.2591C58.2178 15.8294 58.9461 16.1219 59.7861 16.1219C60.6778 16.1219 61.4278 15.8294 62.0195 15.2526C62.4095 14.8707 62.6311 14.3442 62.6895 13.6714H59.7861V12.7322H63.6595C63.7061 12.9353 63.7195 13.1319 63.7195 13.3221Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M69.8636 10.0665H66.2253V12.5365H69.5053V13.4757H66.2253V15.9457H69.8636V16.9029H65.1953V9.10938H69.8636V10.0665Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M74.1992 16.9029H73.1692V10.0665H70.9375V9.10938H76.4325V10.0665H74.1992V16.9029Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M80.4141 16.9029V9.10938H81.4424V16.9029H80.4141Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "T_2",
    d: "M85.996 16.9029H84.9744V10.0665H82.7344V9.10938H88.236V10.0665H85.996V16.9029Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M98.6388 15.8993C97.8504 16.6874 96.8737 17.0807 95.7087 17.0807C94.5371 17.0807 93.5604 16.6874 92.7721 15.8993C91.9854 15.1128 91.5938 14.1476 91.5938 13.0052C91.5938 11.8628 91.9854 10.8976 92.7721 10.1111C93.5604 9.32294 94.5371 8.92969 95.7087 8.92969C96.8671 8.92969 97.8438 9.32294 98.6321 10.1176C99.4254 10.9106 99.8171 11.8693 99.8171 13.0052C99.8171 14.1476 99.4254 15.1128 98.6388 15.8993ZM93.5338 15.2461C94.1271 15.8294 94.8487 16.1219 95.7087 16.1219C96.5621 16.1219 97.2904 15.8294 97.8771 15.2461C98.4688 14.6627 98.7687 13.9136 98.7687 13.0052C98.7687 12.0968 98.4688 11.3477 97.8771 10.7643C97.2904 10.1809 96.5621 9.88844 95.7087 9.88844C94.8487 9.88844 94.1271 10.1809 93.5338 10.7643C92.9421 11.3477 92.6421 12.0968 92.6421 13.0052C92.6421 13.9136 92.9421 14.6627 93.5338 15.2461Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    d: "M101.266 16.9029V9.10938H102.516L106.402 15.1706H106.447L106.402 13.6724V9.10938H107.431V16.9029H106.357L102.287 10.5426H102.242L102.287 12.0474V16.9029H101.266Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Google Play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Google Play_2",
    d: "M91.3454 28.2744C88.2137 28.2744 85.6554 30.5981 85.6554 33.8043C85.6554 36.9844 88.2137 39.3325 91.3454 39.3325C94.4837 39.3325 97.0421 36.9844 97.0421 33.8043C97.0421 30.5981 94.4837 28.2744 91.3454 28.2744ZM91.3454 37.155C89.6271 37.155 88.1487 35.7721 88.1487 33.8043C88.1487 31.8104 89.6271 30.4519 91.3454 30.4519C93.0637 30.4519 94.5487 31.8104 94.5487 33.8043C94.5487 35.7721 93.0637 37.155 91.3454 37.155ZM78.9304 28.2744C75.7921 28.2744 73.2404 30.5981 73.2404 33.8043C73.2404 36.9844 75.7921 39.3325 78.9304 39.3325C82.0671 39.3325 84.6204 36.9844 84.6204 33.8043C84.6204 30.5981 82.0671 28.2744 78.9304 28.2744ZM78.9304 37.155C77.2104 37.155 75.7271 35.7721 75.7271 33.8043C75.7271 31.8104 77.2104 30.4519 78.9304 30.4519C80.6487 30.4519 82.1271 31.8104 82.1271 33.8043C82.1271 35.7721 80.6487 37.155 78.9304 37.155ZM64.1571 29.9693V32.319H69.9121C69.7437 33.632 69.2937 34.5973 68.6037 35.27C67.7637 36.0825 66.4554 36.9844 64.1571 36.9844C60.6154 36.9844 57.8421 34.1975 57.8421 30.7444C57.8421 27.2913 60.6154 24.5044 64.1571 24.5044C66.0721 24.5044 67.4654 25.234 68.4937 26.1798L70.1921 24.5239C68.7537 23.1849 66.8404 22.1563 64.1571 22.1563C59.3004 22.1563 55.2188 26.0091 55.2188 30.7444C55.2188 35.4796 59.3004 39.3325 64.1571 39.3325C66.7821 39.3325 68.7537 38.494 70.3037 36.921C71.8921 35.3724 72.3871 33.1949 72.3871 31.4366C72.3871 30.8906 72.3404 30.3885 72.2571 29.9693H64.1571ZM124.567 31.7909C124.099 30.5543 122.654 28.2744 119.71 28.2744C116.794 28.2744 114.365 30.5153 114.365 33.8043C114.365 36.9015 116.769 39.3325 119.99 39.3325C122.595 39.3325 124.099 37.7839 124.717 36.882L122.784 35.6259C122.139 36.5456 121.26 37.155 119.99 37.155C118.729 37.155 117.824 36.5911 117.244 35.4796L124.829 32.4198L124.567 31.7909ZM116.834 33.632C116.769 31.5 118.532 30.408 119.795 30.408C120.785 30.408 121.625 30.8906 121.905 31.5813L116.834 33.632ZM110.669 38.9961H113.162V22.7461H110.669V38.9961ZM106.585 29.5061H106.502C105.942 28.8594 104.874 28.2744 103.52 28.2744C100.68 28.2744 98.0837 30.7054 98.0837 33.8221C98.0837 36.921 100.68 39.3325 103.52 39.3325C104.874 39.3325 105.942 38.7426 106.502 38.0764H106.585V38.8694C106.585 40.9835 105.427 42.1194 103.559 42.1194C102.035 42.1194 101.09 41.0469 100.7 40.145L98.5321 41.0274C99.1571 42.4931 100.812 44.2969 103.559 44.2969C106.482 44.2969 108.949 42.6199 108.949 38.5395V28.6108H106.585V29.5061ZM103.734 37.155C102.015 37.155 100.577 35.7526 100.577 33.8221C100.577 31.8738 102.015 30.4519 103.734 30.4519C105.427 30.4519 106.762 31.8738 106.762 33.8221C106.762 35.7526 105.427 37.155 103.734 37.155ZM136.24 22.7461H130.277V38.9961H132.764V32.839H136.24C139.002 32.839 141.71 30.8906 141.71 27.7918C141.71 24.6945 138.995 22.7461 136.24 22.7461ZM136.305 30.5786H132.764V25.0065H136.305C138.162 25.0065 139.222 26.5096 139.222 27.7918C139.222 29.0495 138.162 30.5786 136.305 30.5786ZM151.677 28.2435C149.88 28.2435 148.012 29.017 147.244 30.7314L149.45 31.6333C149.925 30.7314 150.799 30.4389 151.722 30.4389C153.012 30.4389 154.32 31.1945 154.34 32.5286V32.6993C153.89 32.4458 152.927 32.0704 151.742 32.0704C149.365 32.0704 146.944 33.346 146.944 35.7266C146.944 37.9041 148.89 39.3065 151.079 39.3065C152.752 39.3065 153.675 38.5704 154.255 37.714H154.34V38.9701H156.742V32.7366C156.742 29.8555 154.535 28.2435 151.677 28.2435ZM151.377 37.1485C150.564 37.1485 149.43 36.7553 149.43 35.7721C149.43 34.5144 150.844 34.0318 152.067 34.0318C153.162 34.0318 153.675 34.2674 154.34 34.5778C154.145 36.0825 152.817 37.1485 151.377 37.1485ZM165.492 28.5994L162.634 35.6438H162.549L159.594 28.5994H156.912L161.352 38.4436L158.819 43.9215H161.417L168.259 28.5994H165.492ZM143.077 38.9961H145.57V22.7461H143.077V38.9961Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8315_15206",
    x1: 29.5681,
    y1: 40.6726,
    x2: 7.758,
    y2: 18.3032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8315_15206",
    x1: 45.6104,
    y1: 25.9921,
    x2: 13.3479,
    y2: 25.9921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8315_15206",
    x1: 33.6034,
    y1: 23.0125,
    x2: 4.02709,
    y2: -7.3222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8315_15206",
    x1: 10.2305,
    y1: 51.7709,
    x2: 23.4376,
    y2: 38.2253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.421947c7e5317cfd697bf564d961b6ff.svg";
export { ForwardRef as ReactComponent };